import { DomainDataType } from "../types/DomainDataType";
import { BaseApi } from "./BaseApi";
import { Vendedor } from "../../types/Vendedor";

export class VendedorApi extends BaseApi {
    async autenticar(senha:string) : Promise<DomainDataType<VendedorApi_Autentar_Output>> {
        return (await this.api.post(`/Vendedor/Autenticar2`,{
            SenhaVendedor:senha,
            loginParaCriarAlterarOrcamento: true
        }))?.data
    }

    async vendedorGerente(codigoVendedor: string): Promise<{ Gerente: boolean }> {
        const resposta = await this.api.get("/Vendedor/VendedorGerente",{
            params: {
                codigoVendedor,
            }
        })
        return resposta.data
    }

    async desconectar(): Promise<void> 
    {
        const vendedor = await this.api.get(`/Vendedor/Cancelar`)
    }

    async ListarFiliaisOrcamentoSimplificado() : Promise<{
        Oid: number,
        Descricao: string
    }[]> {
        const retorno = await this.api.get(`/Vendedor/ListarFiliaisOrcamentoSimplificado`)
        
        return retorno.data
    }
    

    async listarFiliaisOrcamento() : Promise<{
        Oid: number,
        Descricao: string
    }[]> {
        
        return (await this.api.get(`/Vendedor/ListarFiliaisOrcamento`)).data
    }

    async alterarFilial(oidFilial:number) {
        await this.api.post(`/Vendedor/AlterarFilial`,{oidFilial})
    }

    async alterarSenha(senhaAtual:string, novaSenha:string) : Promise<DomainDataType<any>> {
        await this.api.post(`/Vendedor/AlterarSenha`,{
            senhaAtual, novaSenha
        })
    }

    async ObterVendedorAutenticado(): Promise<Vendedor> {
        
        const vendedor = await this.api.get(`/Vendedor/ObterVendedorAutenticado`)
        
        return vendedor.data
    }

    async listarPorNomePessoa(nome: string): Promise<Vendedor[]> {
        return (await this.api.post(`/Vendedor/ListarPorNomePessoa`, { nome })).data
    }

    async ListarPorNome(nome: string): Promise<Vendedor[]> {
        const vendedor = await this.api.post(`/Vendedor/ListarPorNome`, {

                nome: nome
            
        })
        return vendedor.data
    }

    async ListarSimplificado(nome: string): Promise<Vendedor[]> {
        const vendedor = await this.api.post(`/Vendedor/ListarSimplificado`, {

                nome: nome
            
        })
        return vendedor.data
    }    
}

export type VendedorApi_Autentar_Output = {
    Autenticado: boolean,
    AlterarSenha: boolean
}
